import { animate, state, style, transition, trigger } from '@angular/animations';
import {
    Component,
    ContentChild, EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef
} from '@angular/core';

@Component({
    selector: 'ft-tree-node',
    templateUrl: './tree-node.component.html',
    styleUrls: ['./tree-node.component.scss'],
    animations: [
        trigger('slideDown', [
            state('1', style({
                height: '*'
            })),
            state('0', style({
                height: '0'
            })),
            transition('0 <=> 1', animate(200))
        ])
    ]
})
export class TreeNodeComponent implements OnInit {
    @Input() isCollapsed = true;
    @ContentChild('node') nodeTemplate: TemplateRef<any>;
    @ContentChild('children') childrenTemplate: TemplateRef<any>;
    @Output() remove = new EventEmitter();
    @Input() removable = false;
    @Input() modifierClass: string = null;

    constructor() {
    }

    collapse() {
        this.isCollapsed = true;
    }

    expand() {
        this.isCollapsed = false;
    }

    ngOnInit(): void {
    }

}
